/**
 * StaticContentPage
 * Renderer for legacy Django-template HTML that is stored in `staticPages.js`.
 *
 * Safety/behavior:
 * - strips any `<!DOCTYPE ...>` wrapper from embedded HTML
 * - updates document title for route context
 * - renders fallback panel when a page has no content
 */
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

function normalizeMarkup(html) {
  if (!html) {
    return '';
  }

  return html.replace(/<!DOCTYPE[^>]*>/gi, '').trim();
}

export default function StaticContentPage({ title, html }) {
  const location = useLocation();
  const normalizedHtml = useMemo(() => normalizeMarkup(html), [html]);
  const routeClassName = useMemo(() => {
    const slug = location.pathname
      .replace(/^\/+|\/+$/g, '')
      .replace(/[^a-z0-9_-]/gi, '-')
      .toLowerCase();

    return slug ? `route-${slug}` : 'route-home';
  }, [location.pathname]);

  useEffect(() => {
    if (!title) {
      document.title = 'Disinformation Warriors';
      return;
    }

    document.title = `${title} | Disinformation Warriors`;
  }, [title]);

  return (
    <section className={`site-template-content ${routeClassName}`}>
      {normalizedHtml ? (
        <div dangerouslySetInnerHTML={{ __html: normalizedHtml }} />
      ) : (
        <div className="panel_text">
          <p>This page is currently not available.</p>
        </div>
      )}
    </section>
  );
}
